import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TestBed } from '@angular/core/testing';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@uigy/core/core.module';
import {
  PcapPlayerGridButtonsComponent,
} from '@uigy/modules/settings/modules/pcap-player/components/pcap-player-grid-buttons/pcap-player-grid-buttons.component';

import {
  PcapPlayerComponent,
} from '@uigy/modules/settings/modules/pcap-player/components/pcap-player/pcap-player.component';
import {
  PlayPcapFormComponent,
} from '@uigy/modules/settings/modules/pcap-player/components/play-pcap-form/play-pcap-form.component';
import { PcapPlayerRoutingModule } from '@uigy/modules/settings/modules/pcap-player/pcap-player-routing.module';
import {
  PcapPlayerGridPageService,
} from '@uigy/modules/settings/modules/pcap-player/services/pcap-player-grid-page.service';
import { ExportButtonComponent } from '@uigy/shared/components';
import { NotificationComponent } from '@uigy/shared/components/info/notification.component';
import { OverlaysService } from '@uigy/shared/components/slider-v2/services/overlays.service';
import { UploadFileComponent } from '@uigy/shared/components/upload-file/upload-file.component';
import { MaxFileSizeValidatorDirective } from '@uigy/shared/directives/max-file-size-validator.directive';
import { FlyoutComponent } from '@uigy/shared/flyout/flyout/flyout.component';
import { GridPageComponent } from '@uigy/shared/modules/grid/grid-pages/grid-page/grid-page.component';
import {
  GenericBasicGridComponent,
} from '@uigy/shared/modules/grid/grids/components/generic-basic-grid/generic-basic-grid.component';
import { SearchComponent } from '@uigy/shared/components/search/search.component';
import { UIButtonComponent } from '@uigy/shared/components/ui-button/ui-button.component';
import { UiSelectComponent } from '@uigy/shared/components/ui-inputs/ui-select/ui-select.component';

@NgModule({
  declarations: [
    PlayPcapFormComponent,
    PcapPlayerComponent,
    PcapPlayerGridButtonsComponent,
  ],
  imports: [
    CommonModule,
    PcapPlayerRoutingModule,
    UiSelectComponent,
    GenericBasicGridComponent,
    GridPageComponent,
    UploadFileComponent,
    MaxFileSizeValidatorDirective,
    FlyoutComponent,
    NotificationComponent,
    UIButtonComponent,
    SearchComponent,
    ExportButtonComponent,
    ReactiveFormsModule,
  ],
  providers: [PcapPlayerGridPageService],
  exports: [
    PlayPcapFormComponent,
    PcapPlayerComponent,
    PcapPlayerGridButtonsComponent,
    PcapPlayerRoutingModule,
  ]
})
export class PcapPlayerModule {
  static forTest(): TestBed {
    return CoreModule.forTest({
      providers: [OverlaysService]
    }).overrideModule(PcapPlayerModule, {
      remove: {
        imports: []
      }
    });
  }
}
